import { Component } from '@angular/core';

@Component({
  selector: 'lfx-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: true,
})
export class AuthComponent {}
